/* sp-motion.js — parallax, reveal-on-scroll, header solidify, burger, ticker loop.
   Extraido de site/index.html (2026-08-26). Respeita prefers-reduced-motion.
   As seccoes sp-*.liquid so precisam de emitir as classes/atributos certos:
   .hero-strip img | .cat .thumb img | .rrow .thumb img  -> drift in-frame (--par)
   [data-fb]  -> fundo full-bleed com parallax   |   [data-py="N"] -> deriva de elemento
   #track -> conteudo do ticker duplicado para loop continuo */
(function(){

    var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    // ---- Mobile nav ----
    // O painel e um overlay: quando esta aberto tem de se comportar como tal — fecha com
    // Escape, fecha ao clicar fora, e o Tab NAO sai dele para o conteudo por baixo
    // (WCAG 2.4.3 Focus Order + 2.4.11 Focus Not Obscured). Medido no browser: antes,
    // 14 de 14 paragens de Tab caiam fora do #nav, 11 delas em elementos invisiveis.
    var b=document.getElementById('burger'),n=document.getElementById('nav');
    if(b&&n){
      var mqNav=window.matchMedia('(max-width:1279px)');
      // `summary` entra na lista: os pais do submenu sao <summary>, nao <a> nem <button>,
      // e sem isto o Tab saltava-os dentro do painel mobile.
      var SEL_FOCO='a[href],summary,button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
      // A armadilha e o CABECALHO inteiro, nao so o painel: o wordmark e os 3 icones ficam
      // visiveis e por cima do overlay, portanto tem de continuar alcancaveis pelo teclado.
      var escopoFoco=b.closest('header')||n;

      function navAberto(){return n.classList.contains('open');}
      function navEstado(open){
        n.classList.toggle('open',open);
        b.setAttribute('aria-expanded',open?'true':'false');
      }
      function navAbrir(){
        navEstado(true);
        var f=n.querySelector(SEL_FOCO);
        if(f)f.focus();
      }
      function navFechar(devolverFoco){
        navEstado(false);
        if(devolverFoco)b.focus();
      }
      function navFocaveis(){
        return [].slice.call(escopoFoco.querySelectorAll(SEL_FOCO)).filter(function(el){
          return el.offsetWidth>0||el.offsetHeight>0||el===document.activeElement;
        });
      }

      b.addEventListener('click',function(){if(navAberto())navFechar(false);else navAbrir();});
      n.addEventListener('click',function(e){if(e.target.closest('a')){navFechar(false);}});

      // Clique fora do cabecalho fecha (o clique no proprio burger e tratado acima).
      document.addEventListener('click',function(e){
        if(!navAberto())return;
        if(escopoFoco.contains(e.target))return;
        navFechar(false);
      });

      // Submenus: um <details> aberto e um painel flutuante no desktop, onde o overlay do
      // burger nao existe. Fecha ao clicar fora dele e com Escape, como qualquer dropdown.
      function fecharSubmenus(excepto){
        [].slice.call(n.querySelectorAll('details.nav-group[open]')).forEach(function(d){
          if(d!==excepto)d.open=false;
        });
      }
      n.addEventListener('click',function(e){
        var alvo=e.target.closest('details.nav-group');
        if(alvo)fecharSubmenus(alvo);
      });
      document.addEventListener('click',function(e){
        if(!n.contains(e.target))fecharSubmenus(null);
      });
      document.addEventListener('keydown',function(e){
        if(e.key!=='Escape'&&e.key!=='Esc')return;
        var aberto=n.querySelector('details.nav-group[open]');
        if(!aberto)return;
        var s=aberto.querySelector('summary');
        aberto.open=false;
        if(s&&aberto.contains(document.activeElement))s.focus();
        // Escape fecha o mais interior primeiro: sem isto, no painel mobile o mesmo
        // Escape fechava o submenu E o menu inteiro no mesmo toque.
        e.stopImmediatePropagation();
      });

      document.addEventListener('keydown',function(e){
        if(!navAberto()||!mqNav.matches)return;
        if(e.key==='Escape'||e.key==='Esc'){e.preventDefault();navFechar(true);return;}
        if(e.key!=='Tab')return;
        var itens=navFocaveis();
        if(!itens.length)return;
        var i=itens.indexOf(document.activeElement),proximo;
        if(e.shiftKey){proximo=(i<=0)?itens.length-1:i-1;}
        else{proximo=(i===-1||i===itens.length-1)?0:i+1;}
        e.preventDefault();
        itens[proximo].focus();
      });
    }

    // Header shadow on scroll
    var hd=document.querySelector('header');
    if(hd){
      var onHd=function(){hd.classList.toggle('scrolled',window.scrollY>16);};
      onHd();window.addEventListener('scroll',onHd,{passive:true});
    }

    // Duplicate ticker content for seamless loop
    var track=document.getElementById('track');
    if(track){track.innerHTML+=track.innerHTML;}

    if(reduce)return;

    // ---- Parallax engine ----
    var pimgs=[].slice.call(document.querySelectorAll('.hero-strip img, .cat .thumb img, .rrow .thumb img'));
    var fbs=[].slice.call(document.querySelectorAll('[data-fb]'));
    var pys=[].slice.call(document.querySelectorAll('[data-py]')); // arbitrary elements (index numerals)
    var ticking=false;
    function apply(){
      var vh=window.innerHeight;
      // in-frame image drift
      pimgs.forEach(function(img){
        var r=img.getBoundingClientRect();
        if(r.bottom<-120||r.top>vh+120)return;
        var prog=(r.top+r.height/2-vh/2)/vh; // -1..1
        img.style.setProperty('--par',(-prog*34).toFixed(1)+'px');
      });
      // full-bleed background parallax (bigger)
      fbs.forEach(function(el){
        var band=el.parentElement;var r=band.getBoundingClientRect();
        if(r.bottom<-200||r.top>vh+200)return;
        var prog=(r.top+r.height/2-vh/2)/vh;
        el.style.transform='translate3d(0,'+(-prog*90).toFixed(1)+'px,0)';
      });
      // element drift (index numerals) — depth layer
      pys.forEach(function(el){
        var r=el.getBoundingClientRect();
        if(r.bottom<-200||r.top>vh+200)return;
        var prog=(r.top+r.height/2-vh/2)/vh;
        var amp=parseFloat(el.getAttribute('data-py'))||0;
        el.style.transform='translate3d(0,'+(-prog*amp).toFixed(1)+'px,0)';
      });
      ticking=false;
    }
    function req(){if(!ticking){ticking=true;requestAnimationFrame(apply);}}
    window.addEventListener('scroll',req,{passive:true});
    window.addEventListener('resize',req,{passive:true});
    apply();

    // ---- Reveal on scroll ----
    if('IntersectionObserver'in window){
      var groups=[
        ['.sec-head',0],['.cat-grid .cat',1],['.rail .rrow',1],
        ['.spotlight .inner',0],['.custom .inner',0],
        ['.why .col',1],['.rep-grid .rep',1],['.news .inner',0]
      ];
      var io=new IntersectionObserver(function(es){
        es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});
      },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
      groups.forEach(function(g){
        document.querySelectorAll(g[0]).forEach(function(el,i){
          el.classList.add('reveal');
          if(g[1]){el.classList.add('d'+((i%5)+1));}
          io.observe(el);
        });
      });
    }
  })();